'use client'

import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/Carousel';

import Star from '@/components/icons/Star';
import ImageLoading from '@/components/ImageLoading';
import useSetSearchParams from '@/hooks/useSetSearchParams';
import { Provider1HotelType } from '@/types/provider1';
import getNextDate from '@/utils/getNextDay';
import { deslugify } from '@/utils/slugify';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import slugify from 'slugify';
import HotelBoxV2 from '../HotelBoxV2';
import NavigateToSearchPage from '../NavigateToSearchPage';
import HotelLoading from './loading2';
import { provider1FormatHotel } from '@/components/hotels/utils/provider1FormatHotel';
import { calculateDateDistance } from '@/utils/dateOperators/calculateDateDistance';
import NextLink from '@/components/NextLink';
import Provider1RecommendedHotelCard from '@/components/hotels/Provider1RecommendedHotelCard';

export default function Recommended() {
    const { params: { checkIn = getNextDate(1), checkOut = getNextDate(2), passenger }, mainParams: { hotelName, city, country } } = useSetSearchParams();
    const [hotels, setHotels] = useState<Provider1HotelType[] | null>(null);
    const [loading, setLoading] = useState(false);

    async function fetchHotels(city: string) {

        setLoading(true)

        const payload = {
            city: city ? deslugify(city.toLowerCase())?.toLowerCase() : undefined,
            country: city ? deslugify(country?.toLowerCase() || "")?.toLowerCase() : undefined,
            destination: city ? undefined : slugify(country || "")?.toLowerCase(),
            checkIn,
            checkOut,
            filter: {},
            passenger,
            sortBy: "recommended",
        };

        const res = await fetch("/api/hotels/provider1GetAllOnline", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        if (!res.ok) {
            console.error("Failed to fetch:", await res.text());
            throw new Error("Failed to fetch Provider1 data");
        }

        const { hotels } = await res.json();

        setHotels(hotels);
        setLoading(false)
    }

    useEffect(() => {

        if (!city) return;

        const timer = setTimeout(() => {
            fetchHotels(city);
        }, 5);
        return () => clearTimeout(timer);
    }, [city]);


    const currency = Cookies.get('currency') || 'USD';

    const duration = calculateDateDistance(checkIn, checkOut);


    return loading ? <HotelLoading /> : (hotels && hotels.length > 0) ? (
        <HotelBoxV2>
            <div className='flex items-end sm:items-center justify-between pb-2'>
                <h2 className="text-gray-900 flex gap-1 flex-wrap">
                    <span>Other Hotels in</span>
                    <span className='capitalize'>{deslugify(city)}</span>
                </h2>
                <NavigateToSearchPage country={country} city={city} checkIn={checkIn} checkOut={checkOut} passenger={passenger}>
                    <div className='text-xs min-w-max text-secondary-500 flex items-center gap-0.5'>
                        <span>See more</span>
                        <FontAwesomeIcon icon={faChevronRight} className='w-4 flex items-center justify-center' />
                    </div>
                </NavigateToSearchPage>
            </div>
            <Carousel className="w-full mt-5">
                <CarouselContent className="lg:pl-3">

                    {hotels?.map((item: any) => {
                        const formattedHotel = provider1FormatHotel(item, Math.max(duration, 1), currency)
                        return (
                            <CarouselItem
                                key={formattedHotel.id}
                                className="md:px-2 flex flex-col !basis-3/5 lg:!basis-1/5 rounded-3xl  
                             sm:w-full min-w-[200px] sm:min-w-[250px] px-0.5 first:pl-4 
                                                          sm:first:pl-2">
                                <Provider1RecommendedHotelCard
                                    navigateTo={formattedHotel.navigateTo({ start: checkIn, end: checkOut, passenger, })}
                                    formattedHotel={formattedHotel}
                                />
                            </CarouselItem>
                        )
                    })}

                </CarouselContent>
                <CarouselPrevious className=" hidden md:block backdrop-blur" />
                <CarouselNext className=" hidden md:block backdrop-blur" />
            </Carousel>
        </HotelBoxV2>
    ) : null; // Render nothing if hotels is empty or undefined
}
